import React from 'react';
import MaterialTable from 'material-table';
import iUser from '../interfaces/User';
import iSerial from '../interfaces/Serial';
import { SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

interface Action {
  name?: string;
  icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  disabled?: boolean;
  tooltip?: string;
  cb?: (rowData: iUser & iSerial, name?: string) => void;
  iconCb?: (rowData: iUser & iSerial) => OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  navigate?: (rowData: iUser & iSerial) => void;
}

interface TableProps {
  title: string;
  data: any[];
  columns: { title: string; field: string }[];
  actions: Action[];
}

function isDisabled(rowData: iUser & iSerial, disabled?: boolean) {
  if (disabled !== undefined) {
    return disabled;
  } else {
    return rowData.isApMode === undefined
      ? false
      : rowData.isApMode
      ? false
      : true;
  }
}

function showToolTip(rowData: iUser & iSerial, actionName: Action['name']) {
  if (actionName === 'ban') {
    return rowData.isBanned ? 'Unban user' : 'Ban User';
  }

  if (actionName === 'confirm') {
    return rowData.isConfirmed ? 'UnConfirm user' : 'Confirm User';
  }

  if (actionName === 'reboot') {
    return rowData.isreboot ? 'Unreboot device' : 'Reboot device';
  }
  return '';
}

export default function 
Table({
  title,
  data,
  columns,
  actions = [],
}: TableProps) {
  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          columns={columns}
          data={data}
          title={title}
          actions={actions.map(
            ({ name, icon, iconCb, disabled, tooltip, cb }) => (
              rowData: iUser & iSerial
            ) => ({
              icon: iconCb ? iconCb(rowData) : (icon || ''),
              disabled: isDisabled(rowData, disabled),
              tooltip: tooltip || showToolTip(rowData, name),
              onClick: (_: any, rowData: any) =>
                cb ? cb(rowData, name) : () => null,
            })
          )}
        />
      </div>
    </>
  );
}
